import type { IconData } from '@stacksjs/iconify-core'

export const gridSlash: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M464.453 395V63.547a16 16 0 0 0-16-16H117l32 32h26.847v26.847l32 32V79.547h96.3v96.3H245.3l32 32h26.847V234.7l32 32v-58.851h96.3v96.3h-58.841l32 32h26.847V363Zm-128.3-219.149v-96.3h96.3v96.3ZM16 16.667v22.627l31.547 31.547v377.612a16 16 0 0 0 16 16h377.612l32.214 32.214H496V474.04L38.626 16.667Zm320.151 342.778l73.008 73.008h-73.008Zm-128.3-128.3l73.008 73.008h-73.01Zm0 105.008h96.3v96.3h-96.3Zm-128.3-233.31l73.008 73.008H79.547Zm0 105.008h96.3v96.3h-96.3Zm0 128.3h96.3v96.3h-96.3Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gridSlash
